import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import NewsPreview from "./components/NewsPreview";
import SiteIntro from "./components/SiteIntro";
import SectionHeading from "@/components/base/SectionHeading";
import MovieCard from "@/components/base/MovieCard";
import { movies } from "@/mocks/movies";

const hot = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 12);

export default function Home() {
  return (
    <div>
      <HeroCarousel />

      <div className="mx-auto max-w-7xl space-y-14 px-4 py-12 md:px-6 md:py-16">
        <section>
          <SectionHeading
            icon="ri-apps-2-line"
            title="频道分类"
            subtitle="选择你感兴趣的频道，快速进入专区浏览"
          />
          <CategoryShortcuts />
        </section>

        <section>
          <SectionHeading
            icon="ri-fire-line"
            title="热门推荐"
            subtitle="近期最受关注的高热度作品"
            action={
              <Link
                to="/category/电视剧"
                className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer sm:inline-flex whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            }
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {hot.map((m) => (
              <MovieCard key={m.id} movie={m} />
            ))}
          </div>
        </section>

        <section>
          <SectionHeading
            icon="ri-newspaper-line"
            title="最新娱乐资讯"
            subtitle="追剧之外，第一时间掌握娱乐动态"
            action={
              <Link
                to="/news"
                className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer sm:inline-flex whitespace-nowrap"
              >
                更多资讯
                <i className="ri-arrow-right-line" />
              </Link>
            }
          />
          <NewsPreview />
        </section>

        <SiteIntro />
      </div>
    </div>
  );
}